/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_PricingInputs */

const en_directory_submit_pricing = /** @type {(inputs: Directory_Submit_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing (optional)`)
};

const zh_directory_submit_pricing = /** @type {(inputs: Directory_Submit_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定价（可选）`)
};

/**
* | output |
* | --- |
* | "Pricing (optional)" |
*
* @param {Directory_Submit_PricingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_pricing = /** @type {((inputs?: Directory_Submit_PricingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_PricingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_pricing(inputs)
	return zh_directory_submit_pricing(inputs)
});
export { directory_submit_pricing as "directory.submit.pricing" }